import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCities = lazy(() => import("@/pages/admin/AdminCities"));

export const Route = createFileRoute("/admin/cities")({
  component: AdminCities,
});
